export class LOGOUT {
  execute = (payload, state) => {
    return [true, { idSubUserLogout: true }]
  }
}